module.exports = __webpack_public_path__ + "static/img/Custom-Gray.72ae340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Custom-Gray.png
// module id = spum
// module chunks = 1